import { nth } from 'lodash-es';

export default {
    // banner
    'career.banner.title': `Make fun make sense`,
    'career.banner.description': 'Join us in this journey!',
    'career.banner.buttonText': `View Jobs`,
    // content 1
    'career.content1.title': 'Want to be a part of it?',
    'career.content1.description': `Our belief is that being simple, honest, self-driven and motivated combined with the constant pursuit of the ultimate company atmosphere can help grow a creative and robust team. `,
    // content 2
    'career.content2.1.title': 'Maria',
    'career.content2.1.subtitle': `Unity 3D Programmer`,
    'career.content2.1.description': `“I love being able to create amazing games with like-minded folks here at Habby!”`,
    'career.content2.2.title': 'Joel',
    'career.content2.2.subtitle': `Game Operator`,
    'career.content2.2.description': `“Habby provides a working atmosphere that’s equal, free and loving! It’s great to find yourself and improve yourself here.”`,
    // content 3
    'career.content3.title': 'Where are we',
    'career.content3.description': `We currently have offices in Singapore and Beijing will further grow to other destinations in the future.`,
    'career.content3.location.1.title': 'Beijing, CHN',
    'career.content3.location.1.desc': '10 Positions',
    'career.content3.location.2.title': 'Singapore, SG',
    'career.content3.location.2.desc': '6 Positions',
    // content 4
    'career.content4.modal.applyButtonText': 'Apply',
    'career.content4.title': 'We are hiring',
    'career.content4.description': `If you wish to apply for any of the above roles, please reach out with your Resume/CV to`,
    'career.content4.description.email': 'zhangxinzhe@habby.com',
    'career.content4.jobs.buttonText': 'Details',
    'career.content4.jobs': [
        // 2026.3.23 新增
        {
            title: '游戏研发设计师（策划&技术）',
            location: '北京',
            type: '策划&技术',
            full: 'Internship',
            descriptions: [
                {
                    title: '岗位职责',
                    content:
                        '1.参与 Demo 的完整开发：玩法创意 → 原型实现 → 持续迭代；\n2.在导师指导下，将创意拆解为系统逻辑，并用Unity/C#实现核心玩法；\n3.负责功能模块的编码、调试与性能优化；\n4.与美术、程序紧密协作，推动创意落地，输出可玩版本。'
                },
                {
                    title: '任职要求',
                    content:
                        '1.2026/2027届全日制在校生，可全职实习3个月及以上；\n2.独立或合作完成过可运行的游戏Demo（休闲手游 / 单机 / 独立游戏均可）；\n3.热爱游戏，对开发充满激情，是深度玩家，对游戏和游戏开发有一定思考；\n4.熟练使用Unity与C#、若能熟悉 Unreal、Cocos、C++、Lua 等任一技术更佳；\n5.逻辑清晰，具备良好的分析与问题解决能力，积极开朗，执行力强，善于沟通协作；\n6.投递时请附上作品集或演示视频链接（例如Google Drive、Bilibili、YouTube等）。'
                },
                {
                    title: '你将收获',
                    content:
                        '1.独立参与完整的游戏开发流程，从创意到成品可玩版本；\n2.免费三餐+无限零食饮料+志同道合的伙伴，以及丰富多彩的体育活动与团建；\n3.置身于开放、有趣、鼓励创意的团队氛围中，享受全球顶尖的游戏创作环境。'
                }
            ]
        },
        {
            title: '游戏3D动画设计师',
            location: '北京',
            type: '美术',
            full: 'Internship',
            descriptions: [
                {
                    title: '岗位职责',
                    content:
                        '1.参与手游欧美卡通风格项目的3D动作设计；\n2.根据角色性格进行基础动画制作与设计；\n3.协助制定动作制作规范；\n4.与策划、程序、模型等岗位协作，确保动画符合整体设计需求。'
                },
                {
                    title: '任职要求',
                    content:
                        '1.动画、美术、数字媒体技术等相关专业，2026届在校生优先，实习期间表现优异可转正；\n2.具备扎实的动作设计基础，对动画节奏有基本理解；\n3.熟悉3ds Max、Maya等主流3D动画制作软件（了解Blender者更佳）；\n4.了解Unity动画系统者优先；\n5.热爱游戏行业，有良好的团队协作和沟通能力。'
                }
            ]
        },
        {
            title: '游戏音效设计师',
            location: '北京',
            type: '音效',
            full: 'Internship',
            descriptions: [
                {
                    title: '岗位职责',
                    content:
                        '1.负责游戏产品中原创配乐与音效全流程工作；\n2.根据项目需求，进行音频资源的管理、维护；\n3.配合程序与策划，沟通及解决音频相关问题；\n4.在完成需求的基础上逐步完善制作规范，提升用户体验。'
                },
                {
                    title: '岗位要求',
                    content:
                        '1.音乐制作或录音相关类专业，熟练掌握一款主流编曲软件，擅长多种风格（包括但不限于管弦、电子等）；\n2.热爱游戏，对声音敏感，具备音频设计、制作能力；\n3.能在工作中学习成长，持续优化制作质量与效率；\n4.有即兴创作能力者优先。'
                }
            ]
        },
        {
            title: '游戏原画设计师',
            location: '北京',
            type: '美术',
            full: 'Internship',
            descriptions: [
                {
                    title: '岗位介绍',
                    content:
                        '我们正在寻找充满激情、有创造力且对游戏美术充满热爱的伙伴加入我们的团队。你将与团队一起，共同为玩家打造引人入胜的视觉体验，同时直接参与到游戏的具体制作，在职业生涯初期探索并找到最适合自己的方向。'
                },
                {
                    title: '岗位职责',
                    content:
                        '1.协助绘制或设计游戏demo的美术风格以及所有相关美术资源（设计角色、场景、道具，UI等各种美术资源）；\n2.协助制作游戏内特效、动画或材质贴图；\n3.在资深美术师的指导下，学习并掌握游戏美术制作流程和工具；\n4.参与美术讨论，贡献创意，并接收反馈进行迭代优化；\n5.确保所有美术资源符合游戏整体的美术风格和技术标准。'
                },
                {
                    title: '任职要求',
                    content:
                        '1.美术、设计专业或自学成才，拥有扎实的美术基础和好的审美；\n2.对游戏行业有浓厚的兴趣和热情，理解游戏美术在玩家体验中的重要性；\n3.具备良好的学习能力和沟通能力，能积极主动地与团队成员合作；\n4.熟悉并掌握主流的绘画设计软件，如：Photoshop、Illustrator、Procreate。\n\n请在投递简历时附上你的个人作品集，作品集是展示潜力的重要依据。'
                },
                {
                    title: '加分项',
                    content:
                        '- 熟练掌握 3D 建模软件（如 Maya, Blender, ZBrush, 3ds Max）或游戏引擎（如 Unity, Unreal Engine）。\n- 有个人游戏项目或参与过游戏Jam（游戏开发比赛）的经验。\n- 对欧美美术风格有深入研究。'
                }
            ]
        },
        {
            title: '游戏特效设计师',
            location: '北京',
            type: '美术',
            full: 'Internship',
            descriptions: [
                {
                    title: '岗位职责',
                    content:
                        '1.负责 Unity 项目内游戏 / 交互特效制作，包括技能、UI、场景氛围等特效落地与优化；\n2.配合策划、程序、美术需求，完成特效设计、制作、调试、迭代；\n3.使用 Unity 粒子系统、动画、材质等实现需求。'
                },
                {
                    title: '任职要求',
                    content:
                        '1.1年以内 Unity 特效相关经验 / 实习经验，能独立完成常规游戏特效；\n2.熟练使用Unity 粒子系统，了解材质、贴图等；\n3.会使用主流特效 / 美术工具：AE、PS 等，了解ASE/ShaderGraph加分；\n4.工作踏实、沟通顺畅，能按时交付，愿意持续学习；\n5.对休闲手游特效有兴趣，愿意做好看又好跑的效果。'
                }
            ]
        },
        {
            title: '游戏2D动效设计师',
            location: '北京',
            type: '美术',
            full: 'Internship',
            descriptions: [
                {
                    title: '岗位职责',
                    content:
                        '1.制作游戏UI动效，界面切换演示、过场、交互反馈等动画；\n2.制作游戏内的角色动画，道具动画；\n3.制作游戏内2D特效动画；\n4.参与需求前期设计，给出动画制作方案。'
                },
                {
                    title: '任职要求',
                    content:
                        '1.了解视觉引导等交互相关设计语言；\n2.有坚实的动画节奏表现能力，动画设计有新意；\n3.有UE/UX动效设计的经验；\n4.熟练使用Particle system、spine、Unity2DAnimation；\n5.可以使用AE、XD等软件制作交互演示流程；\n6.爱玩游戏，对游戏行业充满热情，了解时下热门产品，具备一定产品思维，具有良好的团队合作意识和沟通技巧。'
                }
            ]
        },
        // //2026.3.23
        {
            title: 'Game Programmer',
            location: 'Beijing',
            type: '视频设计',
            descriptions: [
                {
                    title: 'Professional Skills',
                    content:
                        '1.Over 4 years of Unity front-end logic development experience.\n2.Proficient in using UGUI, with a deep understanding of UGUI.\n3.Proficient in developing extension tools using Unity.\n4.Proficient in Lua scripting.'
                },
                {
                    title: 'Comprehensive Qualities ',
                    content:
                        '1.Rich experience in business logic design and development, adept at optimizing and refactoring business-related logical structures.\n2.Strong logical thinking ability, strong learning ability, quality-oriented.\n3.Good communication skills, adept at expressing own viewpoints.\n4.Able to quickly build frameworks and prototype designs.'
                }
            ]
        },
        {
            title: 'Game Artist',
            location: 'Beijing',
            type: '运营',
            descriptions: [
                {
                    title: 'Job Requirements',
                    content:
                        '1.Enthusiastic, self-driven, high aesthetic sense, and fun\n2.Good aesthetic sense, strong creativity, able to create designs that captivate players\n3.Excellent graphic design skills and a certain level of illustration (to assist creativity), capable of designing high-quality promotional materials using minimal game resources\n4.Proficient in the European and American cartoon style\n5.Strong sense of purpose, with a clear direction of pursuit, and high quality standards for oneself\n6.Proactive, able to achieve good results in an open and free working environment\n7.Open-minded and receptive to new methods, tools, and optimization of existing work processes\n8.Clear thinking expression, simple, efficient communication, and logical clarity\n9.Familiar with and proficient in common AI drawing tools, such as SD, MJ, etc.\n10.Passionate about games, preferably passionate about Habby games'
                },
                {
                    title: 'Job Responsibilities',
                    content:
                        '1.Work closely with the operations team to discuss and promote creativity, responsible for designing materials for online game operation activities\n2.Use existing artistic resources from projects, combine personal artistic abilities to express creativity, and create illustrations or graphic designs for different scenario requirements\n3.Summarize and accumulate experience based on results, optimize design and efficiency\n4.Communicate and collaborate with outsourcing teams, able to independently control the quality and progress of outsourced designs\n5.Quickly learn about new tools and methods, improve efficiency and quality, and apply them to practical projects'
                }
            ]
        },
        {
            title: 'Senior Game UI Artist',
            location: 'Beijing',
            type: 'Senior Game UI Artist',
            descriptions: [
                {
                    title: 'Job Responsibilities',
                    content:
                        '1.Responsible for the overall visual design packaging of the in-game UI interface;\n2.Establish the UI style for projects;'
                },
                {
                    title: 'Job Requirements',
                    content:
                        `1.Good foundation in graphic design, mature judgment on popular design aesthetics in the market;\n2.Excellent teamwork skills, able to smoothly connect and collaborate with planning, interaction, animation, restoration, and programming processes;\n3.Excellent drawing skills, outstanding graphic design, color composition, and refinement abilities; deep understanding of game interactions;\n4.Strong ability to summarize and analyze designs, able to accumulate certain methodologies in work, and drive the team's design capabilities forward;\n5.Excellent design control ability, rich experience in adhering to basic design standards and managing resource output.`
                }
            ]
        },
        {
            title: 'Game Artist',
            location: 'Beijing',
            type: '游戏原画',
            descriptions: [
                {
                    title: 'Keywords',
                    content:
                        'Western Cartoon, Characters + Scenes, Good Aesthetics, Good Communication, Creative Thinking, Trendy, Understanding of Foreign Trends'
                },
                {
                    title: 'Job Responsibilities',
                    content:
                        '1.Proficient in Western cartoon style, matching the style of Western cartoon projects\n2.Strong goal orientation, with a clear direction and quality standards for their work\n3.Independently communicate with project members to break down requirements, determine solutions, and deliver results on time\n4.Proactively drive progress, work in an open and free environment, and take responsibility for results\n5.Task management and time planning skills, able to handle multiple tasks with different priorities simultaneously\n6.Open-mindedness and willingness to accept new methods and optimize existing work modes\n7.Clear expression of thoughts and logical communication skills\n8.Experience in large companies and successful projects is preferred, with a strong passion for games and a personal understanding of games; enthusiasm for Habby games is a plus'
                },
                {
                    title: 'Job Requirements',
                    content:
                        '1.Over 3 years of game development experience, working closely with project teams, independently communicating to break down requirements, determining solutions, and completing character and scene concept designs within the timeline, driving the design progress of the project\n2.Work closely with other art functions, making adjustments to seek the best presentation results\n3.Simple and smooth communication, able to discuss issues efficiently and clearly, open-minded, and able to accept different opinions\n4.Knowledge and experience in art design methodologies, capable of creating interesting and attractive characters, scenes, and other in-game elements'
                }
            ]
        },
        {
            title: 'Game 2D Animator',
            location: 'Beijing',
            type: 'Operator',
            descriptions: [
                {
                    title: 'Job Responsibilities',
                    content:
                        '1.Create game UI animations, including interface transitions, cutscenes, interaction feedback, etc.;\n2.Participate in the early design stages of requirements, collaborating with UI to propose interaction solutions;'
                },
                {
                    title: 'Requirements',
                    content:
                        `1.Bachelor's degree or higher in Animation, with an understanding of interaction-related design languages such as visual guidance;\n2.Strong ability to express animation rhythm, with creative animation design;\n3.Proficient in using Particle System and Unity2DAnimation;\n4.Ability to use software like AE and XD to create interaction demonstration processes;\n5.Passionate about games, with good aesthetics, proactive and responsible, and possessing good teamwork and communication skills.`
                }
            ]
        },
        {
            title: 'Senior 2D Animator',
            location: 'Singapore',
            type: 'Senior 2D Animator',
            descriptions: [
                {
                    title: 'Job Responsibilities',
                    content:
                        '1.Create visually stunning UIs, 2D animations and VFX for in-game assets, cutscenes etc;\n2.Collaborate with the game development team to ensure all assets meet technical requirements and performance standards;\n3.Conceptualize and develop original animation ideas that best suit a casual mobile game;\n4.Maintain a consistent and high-quality aesthetic across all game elements.\n5.Identify and optimize animation creation processes by leveraging best practices and tools.\n6.Stay current on industry trends, technologies, and emerging techniques in animation.'
                },
                {
                    title: 'Job Requirements ',
                    content:
                        '1.5+ years of experience in western casual or mid-core games mobile game development; Familiar with Western-style game art.\n2.A complete experience in mobile game development with Unity; \n3.Capability to independently create UIs, 2D animations and VFX etc;\n4.Modesty and respect when receiving feedback from your team;\n5.Passion for games! '
                }
            ]
        },
        //2024.12.4 新加坡新增
        {
            title: 'Marketing Video Content Designer (KR)',
            location: 'Seoul',
            type: 'Marketing Video Content Designer (KR)',
            full: 'Full Time(Hybrid)',
            descriptions: [
                {
                    title: '직무 설명:',
                    content:
                        '- 한국 시장을 대상으로 창의적인 UA 및 브랜딩 영상, 마케팅 캠페인, 소셜 미디어, 프로모션용 광고 영상 콘텐츠 제작 \n- 모바일 게임 산업의 최신 트렌드를 반영하여 영상 제작\n- 영상 성과와 마케팅 팀의 피드백을 바탕으로 전략 분석 및 제작'
                },
                {
                    title: '자격 요건:',
                    content:
                        '- 게임 또는 엔터테인먼트 업계에서 2년 이상의 영상 콘텐츠 제작 및 편집 경력이 있으신 분\n- Adobe Premiere Pro (PR), AR, After Effects 등의 영상 편집 소프트웨어에 능숙하신 분\n- 빠르게 변화하는 환경에서 협업하며 기한을 맞출 수 있는 뛰어난 소통 능력이 있으신 분\n- 게임 산업 트렌드에 대한 깊은 이해가 있으신 분\n- 시각적 미적 감각과 스토리텔링 능력이 뛰어나며 세부 사항에 대한 높은 주의력이 있으신 분'
                },
                {
                    title: '우대 사항:',
                    content:
                        '- 영어 또는 중국어 가능자\n- 마케팅에 대한 깊은 이해가 있으신 분\n- 3D 프로그램 사용 경험이 있으신 분'
                }
            ]
        },
        {
            title: 'Marketing Video Content Designer (JP)',
            location: 'Tokyo',
            type: 'Marketing Video Content Designer (JP)',
            full: 'Full Time(Hybrid)',
            descriptions: [
                {
                    title: '職務内容：',
                    content:
                        '- 日本市場をターゲットにした、革新的なユーザー獲得（UA）、ブランド動画広告、およびマーケティングキャンペーン、SNS、プロモーション用の動画コンテンツを制作する。\n- モバイルゲーム業界の最新トレンドを把握し、これらの洞察を動画戦略に取り入れる。\n- 動画のパフォーマンスやマーケティングチームからのフィードバックに基づいて戦略を調整する。'
                },
                {
                    title: '応募条件：',
                    content:
                        '- 動画コンテンツ制作および編集における2年以上の実務経験（ゲームまたはエンターテインメント業界での経験が望ましい）。\n- Adobe Premiere Pro (PR)、After Effects、ARなどの動画編集ソフトウェアに精通していること。\n- 優れたコミュニケーション能力を持ち、迅速なペースでのコラボレーションや締め切り遵守が可能であること。\n- ゲーム業界のトレンドに対する深い理解を持つこと。\n- 優れたストーリーテリング能力、強い視覚的センス、および細部への注意力を有すること。'
                },
                {
                    title: '優遇条件：',
                    content:
                        '- 英語または中国語能力\n- カジュアルゲームマーケティングに対する深い理解\n- 3Dプロジェクトの経験'
                }
            ]
        },
    ]
};
